import styled, { css } from 'styled-components';
import {
  font,
  gutter,
  screen,
  borderColor,
  colors
} from '../../../styles/variables';

const Template = styled.button`
  display: inline-block;
  padding: ${gutter.small} ${gutter.default};
  height: 44px;
  font-size: ${font.size.default};
  font-weight: ${font.weight.normal};
  line-height: 1.5;
  border: 1px solid transparent;
  border-radius: .25rem;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  &:focus{
    outline: none;
  }

  &:disabled{
    cursor: not-allowed;
  }

  &:hover{
    opacity: 0.9;
  }
`;

const buttonColor = '#fff';

export const Button = styled(Template)`
  margin-left: ${gutter.small};
  margin-right: ${gutter.small};

  .icon{
    height: 14px;
  }
  
  ${props => props.primary && css`
    color: ${buttonColor};
    background-color: ${colors.primary.default};
  `}

  ${props => props.info && css`
    color: ${buttonColor};
    background-color: ${colors.info.default};
  `}

  ${props => props.danger && css`
    color: ${buttonColor};
    background-color: ${colors.danger.default};
  `}

  ${props => props.success && css`
    color: ${buttonColor};
    background-color: ${colors.success.default};
  `}

  ${props => props.line && css`
    color: ${buttonColor};
    background-color: ${colors.line};
  `}

  ${props => props.default && css`
    color: ${font.color.default};
    background-color: ${borderColor};
  `}

  ${props => props.fullWidth && css`
    width: 100%;
  `}

  ${props => props.size === 'small' && css`
    height: 38px;
    line-height: 1;
    @media(max-width: ${screen.sm.max}){
      font-size: ${font.size.small};
    }
  `}

  ${props => props.size === 'xs' && css`
    height: 28px;
    line-height: 18px;
    font-size: ${font.size.small};
    padding: 4px 8px;
  `}

  ${props => props.disabled && css`
    opacity: 0.8;
    cursor: not-allowed;
    &:hover{
      opacity: 0.8;
      cursor: not-allowed;
    }
  `}

  ${props => props.fixWidth && css`
    width: 120px;
  `}

  box-shadow: 0 4px 13px -3px rgb(0 0 0 / 40%);

`;

const height = 50;
export const MainButton = styled(Template)`
  color: ${font.color.default};
  background-color: ${colors.primary.default};
  height: ${height}px;
  min-width: 180px;
  padding-left: 34px;
  padding-right: 34px;

  &:disabled{
    background-color: #aaa;
    &:hover, &:focus, &:active{
      opacity: 1;
    }
  }

  .icon{
    height: 18px;
    margin: 0 ${gutter.small};
    vertical-align: sub;
  }

  ${props => props.footPadding === 'large' && css`
    padding-left: 4rem;
    padding-right: 4rem;
  `}

  ${props => props.fullWidth && css`
    width: 100%;
  `}
`;